export const BOMB_CHAIN = {
  chainName: "BOMB Chain",
  rpcUrls: ["https://rpc.bombchain.com"],
  nativeCurrency: {
    name: "BOMB Token",
    symbol: "BOMB",
    decimals: 18,
  },
  chainId: "0x8fc",
  blockExplorerUrls: ["https://bombscan.com"],
};
